import { CHARACTERS, PLAYER } from '../data';
import { ASSETS } from '../assetManifest';

export const getCharactersData = () => {
  return PLAYER.characters?.map(character => {
    return {
      ...character,
      id: character.uid,
      name: character.name,
      portrait: ASSETS.characters[character.prototypeId].path,
      stars: character.rarity,
      level: character.level,
      elements: character.elements || []
    };
  });
};


export const getCharacterData = (characterId) => {
  if (!characterId) {
    characterId = PLAYER.team[0];
  }
  const character = PLAYER.characters.find(char => char.uid === characterId);
  return {
    ...character,
    tags: character.tags || [],
    elements: character.elements || [],
    menuItems: [
      { text: "Overview", icon: "BookOpen", active: true },
      { text: "Equipment", icon: "Sword" },
      { text: "Skills", icon: "Star" },
      { text: "Ascension", icon: "Crown" }
    ]
  };
};